export const Logo = () => {
  return (
    <svg
      width={23}
      height={23}
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 0a2 2 0 00-2 2v19a2 2 0 002 2h19a2 2 0 002-2V2a2 2 0 00-2-2H2zm2.587 10.895l-.4-1.726-.737-3.154h.724c1.572 0 2.866.177 2.977.395.07.122.293 1.1.501 2.188.195 1.074.404 1.999.432 2.04.153.136.445-.435.598-1.197.084-.421.334-1.237.543-1.794l.39-1.02 3.38-.081.502 1.604c.612 1.903 1.155 3.045 1.322 2.746.07-.109.278-.952.487-1.89.473-2.243.626-2.705.89-2.773.376-.109 3.354-.258 3.354-.177 0 .055-.278 1.02-.612 2.162-.766 2.556-1.294 4.622-1.976 7.762l-.529 2.42-3.2-.081-.376-1.02a214.72 214.72 0 01-.96-2.882l-.613-1.876-.584 1.74c-.32.951-.682 2.066-.807 2.488-.209.734-.25.775-.738.856-.654.095-2.38.109-2.755 0-.236-.054-.362-.448-.877-2.678l-.936-4.052z"
        fill="currentColor"
      />
    </svg>
  )
}

export const Info = () => {
  return (
    <svg
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 14.5C3.1339 14.5 0 11.3661 0 7.5C0 3.6339 3.1339 0.5 7 0.5C10.8661 0.5 14 3.6339 14 7.5C14 11.3661 10.8661 14.5 7 14.5ZM7 13.1C8.48521 13.1 9.90959 12.51 10.9598 11.4598C12.01 10.4096 12.6 8.98521 12.6 7.5C12.6 6.01479 12.01 4.59041 10.9598 3.5402C9.90959 2.49 8.48521 1.9 7 1.9C5.51479 1.9 4.09041 2.49 3.0402 3.5402C1.99 4.59041 1.4 6.01479 1.4 7.5C1.4 8.98521 1.99 10.4096 3.0402 11.4598C4.09041 12.51 5.51479 13.1 7 13.1ZM6.3 4H7.7V5.4H6.3V4ZM6.3 6.8H7.7V11H6.3V6.8Z"
        fill="currentColor"
      />
    </svg>
  )
}

export const Sort = () => {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M4.667 8.667L8 12l3.333-3.333M4.667 4L8 7.333 11.333 4" />
      </g>
    </svg>
  )
}

export const Search = () => {
  return (
    <svg
      width={14}
      height={14}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.209 11.002a4.771 4.771 0 004.764-4.779A4.771 4.771 0 006.21 1.445a4.772 4.772 0 00-4.764 4.778 4.772 4.772 0 004.764 4.78zm0 1.445c3.43 0 6.209-2.786 6.209-6.224C12.418 2.786 9.638 0 6.209 0 2.779 0 0 2.786 0 6.223c0 3.438 2.78 6.224 6.209 6.224z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.938 13.991l-3.59-3.662 1.029-1.014 3.59 3.662-1.029 1.014z"
        fill="currentColor"
      />
    </svg>
  )
}

export const Sun = () => {
  return (
    <svg
      width={14}
      height={14}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.5 0h1v2h-1V0zm0 14v-2h1v2h-1zM2 7.5v-1H0v1h2zm10-1h2v1h-2v-1zm-8.182 4.39l-.707-.708-1.414 1.414.707.707 1.414-1.414zm7.778-9.193l.707.707-1.414 1.414-.707-.707 1.414-1.414zM3.111 3.818l.707-.707-1.414-1.414-.707.707L3.11 3.818zm9.192 7.778l-.707.707-1.414-1.414.707-.707 1.414 1.414zM10 7a3 3 0 11-6 0 3 3 0 016 0zm1 0a4 4 0 11-8 0 4 4 0 018 0z"
        fill="currentColor"
      />
    </svg>
  )
}

export const Moon = () => {
  return (
    <svg
      width={12}
      height={13}
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.151 8.975a6.048 6.048 0 01-7.03-7.03 5.04 5.04 0 107.03 7.03zm.638-1.212A5.04 5.04 0 014.969.095 6.05 6.05 0 1012 7.125c-.369.265-.776.48-1.21.638z"
        fill="currentColor"
      />
    </svg>
  )
}

export const Imdb = () => {
  return (
    <svg
      width={30}
      height={16}
      viewBox="0 0 30 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path fill="#131416" d="M2 2h25v12H2z" />
      <path
        d="M16.772 5.102c.249 0 .416.026.509.077a.36.36 0 01.17.242c.024.11.037.36.037.75v3.347c0 .575-.037.927-.113 1.056-.077.13-.276.196-.603.196V5.102zM22.697 7.216c.04-.096.13-.146.263-.146.136 0 .323.056.375.167.047.112.07.35.07.715v2.214c0 .418-.02.682-.064.792-.042.11-.225.165-.365.165-.133 0-.225-.054-.273-.16-.043-.107-.066-.35-.066-.73V7.952c0-.394.02-.638.06-.736z"
        fill="#FFDF35"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.623 0h25.971c.43 0 .844.169 1.148.469.304.3.475.707.475 1.131v12.8c0 .424-.17.831-.475 1.131-.304.3-.717.469-1.148.469H1.624c-.431 0-.844-.169-1.149-.469A1.589 1.589 0 010 14.4V1.6C0 1.176.171.769.475.469.78.169 1.193 0 1.623 0zm1.995 12.26h2.276V3.627H3.618v8.635zm8.118 0h1.985V3.627h-2.974l-.526 4.033-.326-2.193a85.929 85.929 0 00-.27-1.84H6.674v8.635h1.992L8.67 6.56l.84 5.7h1.42l.795-5.828.01 5.829zm7.815-1.009c.073-.259.117-.777.117-1.552h.002V6.666c0-.816-.033-1.364-.083-1.642a1.532 1.532 0 00-.38-.76c-.2-.227-.495-.39-.884-.49-.388-.099-1.025-.148-2.125-.148h-1.7v8.635h2.758c.546 0 .955-.029 1.224-.088.25-.049.485-.154.685-.309.191-.159.327-.373.386-.613zm5.941.184c.07-.253.107-.638.107-1.157V7.856c0-.52-.011-.86-.037-1.02a1.138 1.138 0 00-.24-.532 1.16 1.16 0 00-.474-.347 2.024 2.024 0 00-.786-.14c-.26 0-.596.052-.818.154a1.765 1.765 0 00-.609.463V3.626h-2.19v8.633h2.047l.143-.55c.165.208.374.378.612.499.223.11.559.166.815.166.332.009.658-.089.929-.278.24-.156.418-.39.501-.66z"
        fill="#FFDF35"
      />
    </svg>
  )
}

export const RottenTomatoes = () => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.10795 0L3.08226 0.841337L4.47709 2.04134C2.71579 1.38201 1.2332 2.97468 1.11931 3.60002C2.04652 3.38468 2.61999 3.31868 3.35962 3.37668C-1.35817 6.46603 0.0246074 12.1421 2.39891 14.1061C6.2739 17.1807 11.6241 16.2407 14.3977 13.2287C18.4409 8.90871 15.5822 0.433335 7.45368 1.84401C7.52536 1.06401 7.87776 0.842004 8.28643 0.776004C7.69017 -0.219334 5.82771 0.286668 5.23414 1.69201C5.21605 1.73468 4.10795 0 4.10795 0ZM3.14054 4.81136H4.80068C6.59145 4.81136 6.74219 4.81936 7.179 4.94602C7.88915 5.15069 8.43047 5.59469 8.72859 6.21536C8.76209 6.28603 8.79023 6.3527 8.81569 6.4187L13.9227 6.42403L13.9408 8.36537L12.1018 8.34937V13.3821L10.104 13.3714V8.35671L8.67902 8.36737C8.51592 8.67818 8.27149 8.93938 7.97155 9.12338C7.77927 9.24071 7.77057 9.25004 7.80138 9.29938C7.88647 9.43271 9.22503 11.7274 9.22503 11.7387L6.9539 11.7514L5.60529 9.50071C5.58251 9.46938 5.52355 9.45538 5.37483 9.44471L5.17585 9.43138L5.20064 11.7514L3.14054 11.7261V4.81136ZM5.16111 6.3367L5.17719 6.56203C5.18657 6.68603 5.19327 7.04803 5.19327 7.36603V7.94404L5.58318 7.92737C5.79756 7.9187 6.04879 7.8947 6.14125 7.87537C6.60619 7.77804 6.84336 7.5567 6.86948 7.1967C6.88757 6.9447 6.82728 6.7727 6.66649 6.6167C6.45344 6.4107 6.15666 6.33936 5.50547 6.33803L5.16111 6.3367Z"
        fill="#FF5050"
      />
    </svg>
  )
}

export const Close = () => {
  return (
    <svg
      width={12}
      height={12}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path fill="currentColor" d="M11.294 0L12 .706.706 11.999 0 11.294z" />
      <path fill="currentColor" d="M12 11.294l-.706.706L.001.706.706 0z" />
    </svg>
  )
}

export const External = () => {
  return (
    <svg
      width={12}
      height={12}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M.5.5v11h11V7h-1v3.5h-9v-9H5v-1H.5zm6.5 1v-1h4.5V5h-1V2.219l-4.641 4.64-.719-.718L9.782 1.5H7z"
        fill="currentColor"
      />
    </svg>
  )
}

export const BigLogo = () => {
  return (
    <svg
      width={647}
      height={143}
      viewBox="0 0 647 143"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M530.858 16.37c-6.794 1.923-6.185 1.085-7.055 9.645-.412 4.092-1.826 13.904-3.172 21.799-1.303 7.834-2.454 14.956-2.538 15.764l-.124 1.556 14.851-2.563c13.456-2.341 15.145-2.715 18.031-4.23 6.323-3.227 9.741-7.74 9.529-12.422-.118-3.425-1.122-5.755-3.19-7.441l-1.829-1.512 1.441-.599c2.002-.74 4.626-3.91 5.438-6.476.935-2.797.177-7.921-1.617-10.551-2.838-4.213-7.273-5.789-15.036-5.302-5.878.348-9.858.978-14.729 2.332zm14.416 10.75c3.101 1.522 1.203 4.26-3.499 5.004l-3.05.482.092-1.762c.198-3.104.589-3.643 2.966-4.02 1.189-.187 2.797-.071 3.491.296zm-1.21 17.461c.512.555.558 1.183.292 2.18-.372 1.33-.614 1.474-3.767 1.973-3.669.58-4.036.268-3.374-2.91.269-1.314.459-1.45 3.223-1.728 2.084-.224 3.166-.078 3.626.485zM575.006 12.812c-4.08 1.335-6.226 7.184-7.055 9.646-.829 2.462-1.826 13.903-3.172 21.798-.954 5.74-.418 10.078 1.873 11.835 2.291 1.756 6.005 3.128 10.316 2.923 4.312-.206 11.269-2.102 18.031-4.231 6.762-2.13 9.387-12.664 10.357-21.254.647-5.735 2.254-13.534-.584-17.747-2.839-4.212-7.274-5.788-15.037-5.301-5.878.347-10.649.997-14.729 2.331zm18.177 20.79c-.653 5.511-1.431 6.69-1.697 7.685-.373 1.33-2.651 3.333-7.044 4.029-3.67.58-6.977 1.104-6.775-2.637.203-3.74.311-11.425 2.785-14.2 2.475-2.776 13.978-5.405 12.731 5.123z"
        fill="currentColor"
      />
      <path
        d="M604.444 6.683c-.441.228.245 1.55 2.202 4.207a576.094 576.094 0 016.834 10.043l4.096 6.133-3.589 10.792c-1.975 5.928-3.565 10.947-3.54 11.102.032.207 3.054-.112 6.672-.685l6.615-1.047 1.256-3.112c.685-1.698 1.41-3.137 1.617-3.17.207-.033 1.908 2.347 3.854 5.27 1.894 2.932 3.767 5.39 4.101 5.496.765.144 11.367-2.488 11.672-2.907.138-.127-2.886-4.84-6.737-10.429-3.799-5.597-6.951-10.448-6.992-10.707-.049-.31 1.85-5.378 4.247-11.32 4.137-10.35 5.359-14.675 4.282-15.458-.24-.174-3.202.19-6.553.772l-6.126 1.129-1.391 2.922c-.805 1.61-2.02 3.975-2.778 5.207l-1.335 2.278-1.154-1.937c-.645-1.063-1.971-3.078-2.88-4.47L617.1 4.309l-6.039 1.008c-3.307.524-6.332 1.162-6.617 1.366zM449.373 29.65c-2.353.532-3.846 1.139-4.333 1.746-.443.547-1.217 3.689-1.752 7.005-.534 3.316-1.186 6.227-1.463 6.483-.329.264-1.899.724-3.501.977-3.618.573-3.618.573-2.469-6.23 1.319-7.732 1.634-7.41-6.221-6.168-4.703.745-6.738 1.279-7.034 1.75-.201.402-.807 2.935-1.328 5.666-1.393 7.266-4.431 21.203-5.863 26.886-.684 2.704-1.393 6.26-1.681 7.789-.228 1.572-.635 3.014-.869 3.21-.226.247-.342.849-.252 1.417.147.93.569.916 7.855-.237 5.53-.875 7.772-1.442 8.111-1.972.21-.351 1.03-3.872 1.733-7.797.703-3.926 1.596-7.987 1.906-9.043.609-1.844.799-1.98 3.617-2.585 2.154-.447 2.946-.466 3.028.05.057.362-.44 3.248-1.154 6.434-1.947 8.784-2.327 11.07-2.413 13.202.011 1.746.104 1.997 1.23 2.083.696.049 4.27-.464 7.932-1.096L451.146 78l.676-1.75c1.239-3.215 3.851-17.508 6.298-34.847.494-3.575 1.077-7.587 1.294-8.893.209-1.357.274-2.957.167-3.629-.204-1.292-.307-1.275-10.208.768zM305.938 52.883c-.941.414-1.555 3.901-2.25 13.23-.198 3.103-1.424 12.091-2.659 20.021-1.286 7.938-2.323 14.777-2.404 15.267-.144.764.639.693 6.912-.512 3.911-.725 7.325-1.583 7.594-1.89.269-.308.742-2.343 1.035-4.508.748-5.31 2.45-14.638 2.828-15.599.201-.402.642-.631.977-.525.402.201 1.067 3.062 1.942 8.592l1.317 8.32 5.791-1.234c3.12-.705 6.713-1.433 7.85-1.613 2.171-.344 2.171-.344 2.738-3.453.73-4.089 2.778-18.928 2.924-21.017.016-.903.687-5.036 1.392-9.28.714-4.191 1.333-8.316 1.297-9.21l-.082-1.524-5.244.672c-2.903.406-5.78.967-6.403 1.384-.977.525-1.4 1.864-2.394 7.636-1.292 7.568-1.604 8.942-2.276 9.049-.723.114-2.716-3.438-4.543-8.287-1.046-2.59-2.192-5.48-2.649-6.362l-.83-1.564-5.987 1.001c-3.3.575-6.436 1.178-6.876 1.406zM370.424 42.94c-.711 3.875-1.386 9.65-1.247 10.529.188 1.188.24 1.18 7.888-.03l7.752-1.228-.524 2.043c-.293 1.16-.858 3.95-1.298 6.192-.439 2.242-1.876 8.561-3.177 14.065-1.361 5.46-2.529 10.465-2.585 11.11l-.226 1.254 15.3-2.74.487-1.613c.23-.884.945-4.07 1.572-7.135 1.586-7.72 4.844-22.275 5.374-23.948.416-1.39.571-1.415 7.869-2.835l7.401-1.436.334-1.907c.792-4.364 1.128-7.596.932-8.836l-.213-1.344-22.739 3.6c-17.778 2.814-22.818 3.77-22.9 4.26zM466.253 32.541c-.619 3.118-1.619 7.514-2.154 9.824-.595 2.266-1.124 4.945-1.175 5.96-.052 1.015-.312 2.38-.584 3.006-.631 1.371-5.321 21.609-5.214 22.28.049.31 6.18-.448 16.309-2.051l16.228-2.569.703-2.919c1.19-4.532 2.072-10.34 1.688-10.756-.196-.234-3.794.124-8.032.794-4.703.745-7.837 1.029-8.092.752-.256-.278-.102-1.309.268-2.32l.72-1.81 6.901-1.251c5.203-.93 7.083-1.44 7.613-2.106.93-1.154 2.067-8.697 1.481-9.717-.364-.63-1.474-.614-6.952.253-5.892.932-6.477.92-6.608.092-.376-2.377.454-2.826 8.344-4.181l7.469-1.341.586-4.331c.312-2.38.472-5.054.393-5.89l-.194-1.558-14.288 2.103-14.332 2.162-1.078 5.574zM283.398 60.424c-.32 1.322-.611 3.17-.67 4.132l-.1 1.711 6.876-1.406c3.748-.752 7.075-1.49 7.42-1.651.492-.237 1.429-5.365 1.208-6.76-.057-.362-2.364-.209-7.118.544l-6.977 1.104-.639 2.326zM288.447 68.895l-6.427 1.23-2.744 15.797c-1.482 8.71-2.48 16.126-2.26 16.515.357.579 1.717.47 8.005-.632 8.96-1.63 7.951-.304 9.606-12.274.665-4.502 1.522-10.465 1.924-13.283.401-2.819.642-5.982.59-6.98-.224-2.084.628-2.06-8.694-.373zM113.741 82.043c-.967 1.584-2.733 9.174-3.938 16.622-3.37 20.876-4.214 26.255-4.124 26.823.065.414 2.105.25 7.412-.696l7.314-1.317.885-4.113c.44-2.242 1.068-4.301 1.397-4.565.329-.264 1.898-.725 3.5-.978 3.36-.532 3.044-.853 5.231 5.264.765 2.157 1.72 4.178 2.139 4.482.83.558 13.547-.766 14.335-1.474.278-.256-2.802-8.668-8.011-21.829l-8.479-21.438-8.603 1.203c-6.735.96-8.734 1.383-9.058 2.016zm11.821 16.777l.893 3.302-1.86.294c-1.034.164-1.894.088-1.935-.17-.155-.982.299-8.153.571-8.778.342-.85 1.255 1.231 2.331 5.352zM96.823 84.933c-2.715.589-3.854 1.087-4.376 1.805-.332.583-1.106 3.725-1.597 6.98-.543 3.265-1.195 6.176-1.524 6.44-.329.264-1.898.725-3.5.978-3.566.565-3.55.668-2.464-5.861.434-2.612.8-5.318.79-6.058l-.05-1.317-6.795.917c-5.03.69-6.917 1.148-7.205 1.67-.253.41-.905 3.322-1.464 6.483-1.404 7.533-3.834 18.618-5.602 25.52-.739 3.031-1.453 6.216-1.52 7.128-.077.859-.392 2.551-.745 3.667-.396 1.175-.638 2.326-.589 2.636.057.361 2.614.116 7.92-.83l7.883-1.407.576-2.051c.354-1.115 1.133-4.894 1.73-8.485 1.534-8.719 1.664-8.898 5.127-9.446 3.359-.532 3.375-.429 2.243 4.465-.953 4.018-2.042 9.859-2.653 14.035-.347 2.492-.273 2.957.464 3.264.455.193 4.002-.157 7.878-.77 7.028-1.113 7.132-1.129 7.754-2.552 1.016-2.28 3.474-14.535 5.023-25.164.74-5.361 1.63-11.118 1.902-12.75.776-4.467 1.234-8.936 1.038-10.177-.188-1.188-.292-1.172-10.244.88zM4.79 111.949c2.545 6.378 6.33 15.897 8.437 21.179 3.254 8.173 3.957 9.598 4.868 9.666 1.46.193 7.86-.873 10.233-1.62 1.76-.596 1.89-.776 2.223-3.689.212-1.676.885-6.126 1.5-9.932l1.124-6.959 3.403 6.772c1.854 3.68 4.241 8.388 5.3 10.392l2.01 3.655 11.935-1.571.508-9.51c.642-12.339 1.363-20.505 2.668-30.671.553-4.538 1.006-8.37.973-8.577-.05-.31-11.019 2.009-12.349 2.643-.94.414-1.231 2.26-1.639 11.066-.21 3.689-.479 7.016-.671 7.47-.44 1.235-3.143-2.787-6.563-9.662l-2.825-5.804-12.51 2.298-.833 4.105c-.44 2.242-.88 5.49-.936 7.141-.11 2.984-.852 5.326-1.502 4.899-.128-.138-1.46-3.53-2.83-7.498-1.429-4.012-2.845-7.602-3.177-8.026-.544-.762-5.457-.673-11.297.252l-2.687.425 4.637 11.556zM145.007 82.445c-1.278 7.99-1.833 7.495 7.263 6.055l7.752-1.227-.524 2.043c-.294 1.16-.761 3.564-1.007 5.351-.247 1.788-.712 3.874-1.011 4.663-.405 1.124-2.498 9.984-5.176 21.851-.25 1.099 14.618-1.36 15.289-2.473.296-.471 1.098-3.776 1.806-7.332 1.214-6.39 4.801-22.215 5.546-24.875.415-1.39.467-1.399 7.729-2.707 6.651-1.159 7.358-1.377 7.676-2.38.66-1.853 1.59-10.37 1.198-10.838-.247-.226-9.634 1.048-23.071 3.175l-22.688 3.59-.782 5.104zM232.379 65.808c-2.339.953-5.284 2.426-6.625 3.327-4.645 3.119-7.635 8.995-7.353 14.46.159 2.677.235 2.824 2.782 4.858 1.453 1.147 3.834 2.465 5.284 2.924 2.402.786 2.71 1.055 2.947 2.554.54 3.41.012 3.759-8.466 5.419l-7.608 1.469-1.002 5.721c-.559 3.161-1.221 6.338-1.485 7.016-.255.729-.296 1.477-.065 1.599.24.174 4.364-.214 9.23-.931 16.75-2.28 21.177-5.1 24.021-15.245 2.614-9.26 2.058-11.768-3.406-15.83-3.488-2.626-4.03-3.706-2.681-5.562.739-1.017 1.542-1.303 5.676-1.958l4.858-.769 1.252-5.813c.714-3.186 1.254-6.132 1.189-6.545-.188-1.19-13.067 1.114-18.548 3.306zM201.163 71.784c-.047 1.788-.01 4.304.067 5.626l.142 2.351 4.233-1.115c2.309-.588 4.35-1.207 4.551-1.388.287-.267.27-7.236-.039-9.19-.081-.506-1.539-.572-4.492-.105l-4.333.686-.129 3.135z"
        fill="currentColor"
      />
    </svg>
  )
}

export const Coffee = () => {
  return (
    <svg
      width="17"
      height="24"
      viewBox="0 0 17 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.0195 0.00075L1.80525 2.802H0V5.32125H0.69075L1.398 9.8025H0.29325L1.75425 18.0322L2.691 18.021L3.633 24.0007H12.5513L12.6135 23.6025L13.4925 18.0202L14.3835 18.0315L15.8407 9.80175H14.7855L15.4883 5.3205H16.2465V2.80125H14.3287L13.11 0L3.0195 0.00075ZM3.5475 0.8055H12.5903L13.359 2.58675H2.77275L3.5475 0.8055ZM0.798 3.603H15.4418V4.524H0.798V3.603ZM1.251 10.6027H14.8883L13.7123 17.22L8.06025 17.1607L2.427 17.22L1.251 10.6027Z"
        fill="currentColor"
      />
    </svg>
  )
}

export const Filter = () => {
  return (
    <svg
      width={14}
      height={14}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 8l5-4V0H0v4l5 4v6h4V8zm-1 5V7.52l5-4V1H1v2.52l5 4V13h2z"
        fill="currentColor"
      />
    </svg>
  )
}
